var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    { staticClass: "ma-0" },
    [
      _c(
        "v-col",
        { staticClass: "wsp-wallpaper pb-5", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "mx-4 mt-4 mb-0 py-2" },
            [
              _vm.headerType === "image"
                ? _c("v-col", { staticClass: "pb-0", attrs: { cols: "12" } }, [
                    _c("img", {
                      attrs: { src: _vm.headerMediaUrl, width: "100%" },
                    }),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.headerType === "document"
                ? _c("v-col", { staticClass: "pb-2", attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "pa-2 text-caption text--lighten-2",
                        style: { "background-color": "#eee" },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-2", attrs: { size: "x-small" } },
                          [_vm._v("fa fa-file")]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.headerMediaName) +
                            _vm._s(
                              _vm.headerMediaExtension
                                ? `.${_vm.headerMediaExtension}`
                                : ""
                            ) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.headerType === "video"
                ? _c("v-col", { staticClass: "pb-2", attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "pa-2 text-caption text--lighten-2",
                        style: { "background-color": "#eee" },
                      },
                      [
                        _c(
                          "v-icon",
                          { staticClass: "mr-2", attrs: { size: "x-small" } },
                          [_vm._v("fa fa-video")]
                        ),
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.headerMediaName) +
                            "\n        "
                        ),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.header
                ? _c(
                    "v-col",
                    {
                      staticClass: "py-1 font-weight-bold",
                      attrs: { cols: "12" },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.header))])]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("v-col", { staticClass: "py-1", attrs: { cols: "12" } }, [
                _vm.body
                  ? _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.formattedBody) },
                    })
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "py-1 text-caption text--secondary",
                  attrs: { cols: "12" },
                },
                [
                  _vm.footer
                    ? _c("span", [_vm._v(_vm._s(_vm.footer))])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c(
                "v-col",
                {
                  staticClass: "py-0 text-caption text--secondary text-right",
                  attrs: { cols: "12" },
                },
                [_c("span", [_vm._v("07:42")])]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.buttons, function (button, i) {
            return [
              button.title
                ? _c(
                    "v-card",
                    {
                      key: i,
                      staticClass: "mx-4 mt-1 py-1 text-center info--text",
                    },
                    [_vm._v("\n        " + _vm._s(button.title) + "\n      ")]
                  )
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }